export const useShowMoreFeature = () => {
    function initialize() {
        const showAllButton = document.getElementById("show-all");
        const cardList = document.getElementById("card-list");
        if (!showAllButton || !cardList) return;

        if (cardList.offsetHeight >= cardList.scrollHeight) showAllCards();

        showAllButton.addEventListener("click", () => {
            showAllCards();
        });
    }

    function showAllCards() {
        try {
            document.getElementById("card-list").classList.add("disable-show-more");
            document.getElementById("show-all-wrapper").style.display = "none";

            const listLink = document.getElementById("list-link");
            if (listLink) {
                listLink.style.display = "block";
            }
        } catch (e) {
            console.error("Error hiding show more button", e);
        }
    }

    return {
        initialize,
        hide: showAllCards,
    };
};
